import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    async EncabezadoReporte(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.datos.nrreporte);
        formData.append("svindice", vm.datos.svindice);
        formData.append("aiclave", vm.datos.aiclave);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}RLV/EncabezadoReporte`, formData);
        return response.data[0];
    },
    async DatosDetalle(vm) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", vm.datos.nrreporte);
        datosReporte.append("svindice", vm.datos.svindice);
        datosReporte.append("aiclave", vm.datos.aiclave);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}RLV/DetalleGeneral`, datosReporte);
        return response.data;
    },
    async ObtenerTipoRobo(vm) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", vm.datos.nrreporte);
        datosReporte.append("svindice", vm.datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}RLV/ObtenerTipoRobo`, datosReporte);
        return response.data[0];
    },
    async ObtenerTipoServicioOtro(vm) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", vm.datos.nrreporte);
        datosReporte.append("svindice", vm.datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/ObtenerTipoServicioOtro`, datosReporte).then(response => response.data);
    },
    async ObtenerCatalogoMovimientosJudicializacion(vm) {
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", vm.datos.nrreporte);
        datosReporte.append("svindice", vm.datos.svindice);
        datosReporte.append("aiclave", vm.datos.aiclave);

        let response = await vm.axios.post(`${vm.domain.domainNameForApi}RLV/ObtenerCatalogoMovimientosJudicializacion`, datosReporte);
        return response.data;
    },
    GuardaFechaSiniestro(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/GuardaFechaSiniestro`, data).then(response => response.data);
    },
    ActualizarCausa(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/ActualizarCausa`, data).then(response => response.data);
    },
    ActualizarDenuncia(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/ActualizarDenuncia`, data).then(response => response.data);
    },
    TipoServicio(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/TipoServicio`).then(response => response.data);
    },
    TipoRobo(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/TipoRobo`).then(response => response.data);
    },
    ActualizarTipoServicio(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/ActualizarTipoServicio`, data).then(response => response.data);
    },
    async VerificarDesconclusion(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.datos.nrreporte);
        formData.append("svindice", vm.datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/VerificarDesconclusion`, formData).then(response => response.data)
    },
    async MovAutConclusuion(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.datos.nrreporte);
        formData.append("svindice", vm.datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/Conclusion_MovAutorizado`, formData).then(response => response.data)


    },
    async Conclusion_MovSolicitud(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.datos.nrreporte);
        formData.append("svindice", vm.datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}RLV/Conclusion_MovSolicitud`, formData).then(response => response.data)


    }

    
}